import React, {PureComponent} from 'react';
import './ChoosePhonePageComponent.less';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TandCComponent from '../TandCComponent/TandCComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import ChoosePhoneComponent from '../ChoosePhoneComponent/ChoosePhoneComponent';

class ChoosePhonePageComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            errorTitle: ''
        };
    }

    clearAlert = () => {
        this.setState({error: '', errorTitle: ''});
    };

    handleError = (error, errorTitle) => {
        this.setState({error, errorTitle});
    };

    render() {
        let options = {'firstName': this.props.firstName};
        let cardContent = (
            <ChoosePhoneComponent
                {...this.props}
                handleError={this.handleError}
            />
        );
        let tittleMsg = this.props.firstName ? this.props.lingua.read('lex.header.success', options) : '';
        return (
            <>
                <HeaderSectionComponent title={tittleMsg} titleClass="LoggedOwner"/>
                <CalloutCardComponent content={cardContent} error={this.state.error} errorTitle={this.state.errorTitle} clearAlert={this.clearAlert}/>
                <TandCComponent lingua={this.props.lingua} multiUserEnabled={this.props.multiUserEnabled}/>
            </>
        );
    }
}

export default ChoosePhonePageComponent;
